var interestsForm = {
    bindings : {
        addMsg: '&'
    },
    /**
     * @ngInject
     */
    controller : function InterestsFormCtrl ($sce, $timeout, flux, actions) {
        
        var ctrl = this;
        var formData = {};
        var selectedInterests = [];
        ctrl.interests = [
            {
                id: 'cooking',
                label: 'Madlavning',
                selected: false
            },
            {
                id: 'creative',
                label: 'Kreativ',
                selected: false
            },
            {
                id: 'dance',
                label: 'Dans',
                selected: false
            },
            {
                id: 'friendship',
                label: 'Venskab',
                selected: false
            },
            {
                id: 'gaming',
                label: 'Computerspil',
                selected: false
            },
            {
                id: 'listening_music',
                label: 'Lytte til musik',
                selected: false
            },
            {
                id: 'movie',
                label: 'Film',
                selected: false
            },
            {
                id: 'outdoor',
                label: 'Naturen',
                selected: false
            },
            {
                id: 'playing_music',
                label: 'Spille musik',
                selected: false
            },
            {
                id: 'reading',
                label: 'Læse',
                selected: false
            },
            {
                id: 'shopping',
                label: 'Shopping',
                selected: false
            },
            {
                id: 'sport',
                label: 'Sport',
                selected: false
            },
            {
                id: 'tech',
                label: 'Teknologi',
                selected: false
            },
            {
                id: 'theater',
                label: 'Teater',
                selected: false
            },
            {
                id: 'traveling',
                label: 'Rejser',
                selected: false
            },


        ];
       

        function init () {
        }

        function link () {
        }

        ctrl.submitForm = function submitForm() {
            
            if(selectedInterests.length === 3) {
                formData.interests = selectedInterests;
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml('<span class="interests-icon '+selectedInterests[0]+'"></span><span class="interests-icon '+selectedInterests[1]+'"></span><span class="interests-icon '+selectedInterests[2]+'"></span>'),
                        type: 'send'
                    }
                });
                flux.dispatch(actions.UPDATE_USER, formData);
                $timeout(function() {
                    ctrl.addMsg({
                        $event: {
                            content: $sce.trustAsHtml('Hold da op, hvor er du sej! <a href="/din-ansoegning">Godkend dit valg ved at trykke her.</a> '),
                            type: 'receive'
                        }
                    });
                }, 1000);
            } else {
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml('Ups, du skal vælge 3 interesser.'),
                        type: 'receive'
                    }
                });
            }
        };

        ctrl.onInterestsChange = function onInterestsChange(target){
            if(selectedInterests.length == 3) {
                target.selected = false;
            }
            selectedInterests = _.chain(ctrl.interests).filter({'selected':true}).map('id').value();
        };

        this.$onInit = init;
        this.$postLink = link;
    },
    templateUrl: './angular/components/interests-form.component.html',
};